<template>
    <div>
        <!-- #region Generic-->
        <AlertModal :modalId="alertId" :controller="controller.alertModal" v-if="controller.alertModal != null">
        </AlertModal>
        <LoadingModal :modalId="loadingId" :controller="controller.loadingModal" v-if="controller.loadingModal != null">
        </LoadingModal>
        <TransferConfirmModal :controller="controller.transferConfirmModal" v-if="controller.transferConfirmModal != null">
        </TransferConfirmModal>
        <ConfirmModal :modalId="confirmId" :controller="controller.confirmModal" v-if="controller.confirmModal != null">
        </ConfirmModal>
        <!-- #endregion Generic-->

        <HowToModal :controller="controller.howToModal" v-if="controller.howToModal != null"></HowToModal>
    </div>
</template>
<script>
//Generic modal
import AlertModal from './Component/Alert/AlertModal.vue';
import LoadingModal from './Component/Loading/LoadingModal.vue';
import TransferConfirmModal from './Component/confirm/TransferConfirmModal.vue';
import ConfirmModal from './Component/confirm/ConfirmModal.vue';
//Authen modal
import HowToModal from './Component/HowTo/HowToModal.vue';

/**
 * @property {ModalController} controller (required) /components/Modal/Controller/ModalController.js
 */
export default {
    name: 'ModalMaster',
    props: {
        controller: Object,
    },
    components: {
        //generic
        AlertModal,
        LoadingModal,
        ConfirmModal,
        HowToModal,
        TransferConfirmModal
    },
    data: function () {
        return {
            randomNum: Math.floor(Math.random() * 100000) + '',
            //generic
            alertId: '',
            loadingId: '',
            confirmId: '',
            //Authen
            otpId: '',
        };
    },
    created: function () {
        //generic
        this.alertId = 'alert_modal_' + this.randomNum;
        this.loadingId = 'loading_modal_' + this.randomNum;
        this.confirmId = 'confirm_modal_' + this.randomNum;
        //authen
        this.otpId = 'otp_modal_' + this.randomNum;
    }
}
</script>
